import { createCommentVNode } from "@vue/runtime-core";
export function getVueRendered(h, mjmlDom, defaultSlot, componentName, rootAttribs) {
  function mjmlDomTreeToVueRender(mjmlDom2, isRoot) {
    return mjmlDom2.filter((el) => el.type !== "text").map((el) => {
      if (el.type === "tag") {
        if (isRoot) {
          el.attribs["data-mjml-tag"] = componentName;
        }
        return h(
          el.name,
          isRoot && rootAttribs ? el.attribs : {
            ...el.attribs,
            ...rootAttribs
          },
          mjmlDomTreeToVueRender(el.children, false)
        );
      }
      if (el.type === "comment") {
        if (el.data === "[SLOT CONTENT]" && defaultSlot) {
          return defaultSlot();
        }
        return createCommentVNode(el.data || "");
      }
      throw new Error("Unknown element type: " + el.type);
    });
  }
  return mjmlDomTreeToVueRender(mjmlDom, true);
}
